import React, { Component, Fragment } from "react";
import { isEmpty, get, sortBy } from "lodash";
import { Image, Modal, OverlayTrigger, Tooltip } from "react-bootstrap";
import moment from "moment";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import "react-tabs/style/react-tabs.css";
import {
  DETAILS_DEPENDENT_TYPE,
  dependencyDescription
} from "../createProject/Milestones/milestone.helper";
import MilestoneInfoIcon from "../../assets/info_milestone.png";
import ReadMore from "../readMore";
import IconTime from "../../assets/icon-time.svg";

class ProjectMilestoneDetails extends Component {
  constructor(props) {
    super(props);
    this.state = {
      bucketId: null,
      bucketIdx: 0,
      tableIndex: 0,
      showInfoPopup: false
    };
  }

  getBucketIndex = (bucketID, idx) => {
    this.setState({
      bucketId: bucketID,
      bucketIdx: idx
    });
  };

  getTableIndex = tableID => {
    this.setState({
      tableIndex: tableID
    });
  };

  getDateSuffix = number => {
    if (number == 1 || number == 1 || number == 3) {
      return "";
    } else if (number == 21) {
      return "st";
    } else if (number == 22) {
      return "nd";
    } else if (number == 23) {
      return "rd";
    } else {
      return "th";
    }
  };

  handleDependencyModal = () => {
    this.setState({
      showInfoPopup: !this.state.showInfoPopup
    });
  };

  render() {
    const {
      bucketMilestoneCOS,
      projectMilestoneStatus,
      milestoneLastUpdatedBy,
      cabinetMilestone
    } = this.props;
    console.log(cabinetMilestone);
    const { bucketId, tableIndex, bucketIdx, showInfoPopup } = this.state;
    const statusColors = {
      Completed: "#5CB550",
      COMPLETED: "#5CB550",
      Delayed: "#E53838",
      "On Track": "#5CB550",
      Disabled: "#8d8d8d",
      DELAYED: "#E53838",
      ON_TRACK: "#5CB550",
      "Delay Expected": "#E68909",
      NA: "#8D8D8D"
    };
    const getStatus = {
      ON_TRACK: "On Track",
      COMPLETED: "Completed",
      DELAYED: "Delayed",
      NA: "NA"
    };
    console.log(cabinetMilestone);
    return (
      <Fragment>
        {cabinetMilestone &&
        cabinetMilestone.length != 0 &&
        !cabinetMilestone[0].disabled ? (
          <>
            {" "}
            <div class="pmg-heading-container" style={{ marginBottom: -15 }}>
              <div class="left-border" />
              <h2>CABINET MILESTONES</h2>
            </div>
            <Tabs selectedIndex={0} className="project-details-milestones">
              {!isEmpty(cabinetMilestone) &&
                cabinetMilestone.map((bucket, bucketIdx) => (
                  <TabPanel key={bucketIdx}>
                    <Tabs selectedIndex={0} className="phases-details-wrap">
                      {bucket.completed ? (
                        <div className="complete-status-temp">
                          <p
                            style={{
                              background: "#5CB550"
                            }}
                            className="pmd-status"
                          >
                            {" "}
                            COMPLETED
                          </p>
                          {get(bucket, "bucketStatusDTO.delayInDays") &&
                          get(bucket, "bucketStatusDTO.delayInDays") > 0 &&
                          get(bucket, "bucketStatusDTO.status") ===
                            "COMPLETED" ? (
                            <div className="delayed-by-box">
                              <Image src={IconTime} alt="Time" /> Delay:{" "}
                              <span>
                                {get(bucket, "bucketStatusDTO.delayInDays", "")}{" "}
                                days
                              </span>{" "}
                            </div>
                          ) : null}
                        </div>
                      ) : null}
                      {bucket.completed && (
                        <>
                          <div className="completed-bucket-dates">
                            <div className="scheduled-dates">
                              <h6>SCHEDULED DATE OF START</h6>
                              <div className="dates">
                                <div className="original-dates">
                                  <p className="heading">Original:</p>
                                  <p className="date">
                                    {(!!bucket.originalScheduledStartDate &&
                                      moment(
                                        get(
                                          bucket,
                                          "originalScheduledStartDate",
                                          null
                                        )
                                      ).format("MMMM") +
                                        moment(
                                          get(
                                            bucket,
                                            "originalScheduledStartDate",
                                            null
                                          )
                                        ).format(" DD") +
                                        this.getDateSuffix(
                                          moment(
                                            get(
                                              bucket,
                                              "originalScheduledStartDate",
                                              null
                                            )
                                          ).format("DD")
                                        ) +
                                        moment(
                                          get(
                                            bucket,
                                            "originalScheduledStartDate",
                                            null
                                          )
                                        ).format(", YYYY")) ||
                                      "NA"}
                                  </p>
                                </div>
                                <div className="revised-dates">
                                  <p className="heading">Revised/Actual:</p>
                                  <p className="date">
                                    {(!!bucket.revisedScheduledStartDate &&
                                      moment(
                                        get(
                                          bucket,
                                          "revisedScheduledStartDate",
                                          null
                                        )
                                      ).format("MMMM") +
                                        moment(
                                          get(
                                            bucket,
                                            "revisedScheduledStartDate",
                                            null
                                          )
                                        ).format(" DD") +
                                        this.getDateSuffix(
                                          moment(
                                            get(
                                              bucket,
                                              "revisedScheduledStartDate",
                                              null
                                            )
                                          ).format("DD")
                                        ) +
                                        moment(
                                          get(
                                            bucket,
                                            "revisedScheduledStartDate",
                                            null
                                          )
                                        ).format(", YYYY")) ||
                                      "NA"}
                                  </p>
                                </div>
                              </div>
                            </div>
                            <div className="scheduled-dates">
                              <h6>SCHEDULED DATE OF FINISH</h6>
                              <div className="dates">
                                <div className="original-dates">
                                  <p className="heading">Original:</p>
                                  <p className="date">
                                    {(!!bucket.originalScheduledFinishDate &&
                                      moment(
                                        get(
                                          bucket,
                                          "originalScheduledFinishDate",
                                          null
                                        )
                                      ).format("MMMM") +
                                        moment(
                                          get(
                                            bucket,
                                            "originalScheduledFinishDate",
                                            null
                                          )
                                        ).format(" DD") +
                                        this.getDateSuffix(
                                          moment(
                                            get(
                                              bucket,
                                              "originalScheduledFinishDate",
                                              null
                                            )
                                          ).format("DD")
                                        ) +
                                        moment(
                                          get(
                                            bucket,
                                            "originalScheduledFinishDate",
                                            null
                                          )
                                        ).format(", YYYY")) ||
                                      "NA"}
                                  </p>
                                </div>
                                <div className="revised-dates">
                                  <p className="heading">Revised/Actual:</p>
                                  <p className="date">
                                    {(!!bucket.revisedScheduledFinishDate &&
                                      moment(
                                        get(
                                          bucket,
                                          "revisedScheduledFinishDate",
                                          null
                                        )
                                      ).format("MMMM") +
                                        moment(
                                          get(
                                            bucket,
                                            "revisedScheduledFinishDate",
                                            null
                                          )
                                        ).format(" DD") +
                                        this.getDateSuffix(
                                          moment(
                                            get(
                                              bucket,
                                              "revisedScheduledFinishDate",
                                              null
                                            )
                                          ).format("DD")
                                        ) +
                                        moment(
                                          get(
                                            bucket,
                                            "revisedScheduledFinishDate",
                                            null
                                          )
                                        ).format(", YYYY")) ||
                                      "NA"}
                                  </p>
                                </div>
                              </div>
                            </div>
                            {!!bucket &&
                              (bucket.bucketType === "COST_AND_DATES" ||
                                bucket.bucketType ===
                                  "COST_AND_DATES_AND_AREA") && (
                                <div className="scheduled-dates">
                                  <h6>{bucket.bucketName} Cost</h6>
                                  <div className="dates">
                                    <div className="original-dates">
                                      <p className="heading">Original:</p>
                                      <p className="date">
                                        &#x20B9;{bucket.originalCost} Cr.
                                      </p>
                                    </div>
                                    <div className="revised-dates">
                                      <p className="heading">Revised/Actual:</p>
                                      <p className="date">
                                        &#x20B9;{bucket.revisedCost} Cr.
                                      </p>
                                    </div>
                                  </div>
                                </div>
                              )}
                            {!!bucket &&
                              (bucket.bucketType ===
                                "COST_AND_DATES_AND_AREA" && (
                                <div className="scheduled-dates">
                                  <h6>{bucket.bucketName} Area</h6>
                                  <div className="dates">
                                    <div className="original-dates">
                                      <p className="heading">Original:</p>
                                      <p className="date">
                                        {bucket.originalArea} Ha.
                                      </p>
                                    </div>
                                    <div className="revised-dates">
                                      <p className="heading">Revised/Actual:</p>
                                      <p className="date">
                                        {bucket.revisedArea} Ha.
                                      </p>
                                    </div>
                                  </div>
                                </div>
                              ))}
                          </div>
                          <div>
                            <div className="scheduled-dates">
                              <h6>REASON FOR DELAY</h6>
                              <p className="date">{bucket.bucketDelayReason}</p>
                            </div>
                          </div>
                        </>
                      )}
                      {!isEmpty(bucket) &&
                        !isEmpty(bucket.milestoneTableDataCOS) &&
                        bucket.milestoneTableDataCOS.map(
                          table =>
                            !bucket.completed && (
                              <TabPanel key={table.tableIndex}>
                                <div className="activity-head-wrap">
                                  <h5 className="activity-heading">
                                    Milestones (
                                    {
                                      get(
                                        bucket,
                                        "milestoneTableDataCOS[0].milestoneDataCOS",
                                        []
                                      ).length
                                    }
                                    )
                                  </h5>
                                </div>
                                {table.tableIndex === tableIndex &&
                                  !isEmpty(table.milestoneDataCOS) &&
                                  sortBy(
                                    table.milestoneDataCOS,
                                    o => o.disabled
                                  ).map(milestone => {
                                    let prefixOriginalStart = this.getDateSuffix(
                                      moment(
                                        get(
                                          milestone,
                                          "originalScheduledStartDate",
                                          null
                                        )
                                      ).format("DD")
                                    );
                                    let prefixRevisedStart = this.getDateSuffix(
                                      moment(
                                        get(
                                          milestone,
                                          "revisedScheduledStartDate",
                                          null
                                        )
                                      ).format("DD")
                                    );
                                    let prefixOriginalFinish = this.getDateSuffix(
                                      moment(
                                        get(
                                          milestone,
                                          "originalScheduledFinishDate",
                                          null
                                        )
                                      ).format("DD")
                                    );
                                    let prefixRevisedFinish = this.getDateSuffix(
                                      moment(
                                        get(
                                          milestone,
                                          "revisedScheduledFinishDate",
                                          null
                                        )
                                      ).format("DD")
                                    );
                                    return !bucket.completed &&
                                      !milestone.disabled ? (
                                      <Fragment>
                                        <div className="project-milestone-details">
                                          <div className="pmd-heading">
                                            <h5 className="pmd-milestone-name">
                                              {get(
                                                milestone,
                                                "milestone.name",
                                                ""
                                              )}
                                            </h5>
                                            {!!milestone &&
                                              !!milestone.timeDelay && (
                                                <div className="pmd-status-wrapper">
                                                  <p
                                                    style={{
                                                      background:
                                                        statusColors[
                                                          get(
                                                            milestone,
                                                            "timeDelay.key",
                                                            ""
                                                          )
                                                        ]
                                                    }}
                                                    className="pmd-status"
                                                  >
                                                    {get(
                                                      milestone,
                                                      "timeDelay.key",
                                                      ""
                                                    )}
                                                  </p>
                                                  {(get(
                                                    milestone,
                                                    "timeDelay.value"
                                                  ) &&
                                                    get(
                                                      milestone,
                                                      "timeDelay.value"
                                                    ) > 0 &&
                                                    get(
                                                      milestone,
                                                      "timeDelay.key"
                                                    ) !== "Delay Expected") ||
                                                  get(
                                                    milestone,
                                                    "timeDelay.key"
                                                  ) === "Delayed" ? (
                                                    <div className="delayed-by-box">
                                                      <Image
                                                        src={IconTime}
                                                        alt="Time"
                                                      />{" "}
                                                      Delay:{" "}
                                                      <span>
                                                        {get(
                                                          milestone,
                                                          "timeDelay.value",
                                                          ""
                                                        )}{" "}
                                                        days
                                                      </span>{" "}
                                                    </div>
                                                  ) : null}
                                                </div>
                                              )}
                                          </div>
                                          <div className="milestones-wrapper">
                                            <div className="dates-issues">
                                              <div className="scheduled-dates">
                                                <h6>SCHEDULED DATE OF START</h6>
                                                <div className="dates">
                                                  <div className="original-dates">
                                                    <p className="heading">
                                                      Original:
                                                    </p>
                                                    <p className="date">
                                                      {(!!milestone.originalScheduledStartDate &&
                                                        moment(
                                                          get(
                                                            milestone,
                                                            "originalScheduledStartDate",
                                                            null
                                                          )
                                                        ).format("MMMM") +
                                                          moment(
                                                            get(
                                                              milestone,
                                                              "originalScheduledStartDate",
                                                              null
                                                            )
                                                          ).format(" DD") +
                                                          prefixOriginalStart +
                                                          moment(
                                                            get(
                                                              milestone,
                                                              "originalScheduledStartDate",
                                                              null
                                                            )
                                                          ).format(", YYYY")) ||
                                                        "NA"}
                                                    </p>
                                                  </div>
                                                  {!!milestone.revisedScheduledStartDate && (
                                                    <div className="revised-dates">
                                                      <p className="heading">
                                                        Revised/Actual:
                                                      </p>
                                                      <p className="date">
                                                        {(!!milestone.revisedScheduledStartDate &&
                                                          moment(
                                                            get(
                                                              milestone,
                                                              "revisedScheduledStartDate",
                                                              null
                                                            )
                                                          ).format("MMMM") +
                                                            moment(
                                                              get(
                                                                milestone,
                                                                "revisedScheduledStartDate",
                                                                null
                                                              )
                                                            ).format(" DD") +
                                                            prefixRevisedStart +
                                                            moment(
                                                              get(
                                                                milestone,
                                                                "revisedScheduledStartDate",
                                                                null
                                                              )
                                                            ).format(
                                                              ", YYYY"
                                                            )) ||
                                                          "NA"}
                                                      </p>
                                                    </div>
                                                  )}
                                                </div>
                                              </div>
                                              <div className="scheduled-dates">
                                                <h6>
                                                  SCHEDULED DATE OF FINISH
                                                </h6>
                                                <div className="dates">
                                                  <div className="original-dates">
                                                    <p className="heading">
                                                      Original:
                                                    </p>
                                                    <p className="date">
                                                      {(!!milestone.originalScheduledFinishDate &&
                                                        moment(
                                                          get(
                                                            milestone,
                                                            "originalScheduledFinishDate",
                                                            null
                                                          )
                                                        ).format("MMMM") +
                                                          moment(
                                                            get(
                                                              milestone,
                                                              "originalScheduledFinishDate",
                                                              null
                                                            )
                                                          ).format(" DD") +
                                                          prefixOriginalFinish +
                                                          moment(
                                                            get(
                                                              milestone,
                                                              "originalScheduledFinishDate",
                                                              null
                                                            )
                                                          ).format(", YYYY")) ||
                                                        "NA"}
                                                    </p>
                                                  </div>
                                                  {!!milestone.revisedScheduledFinishDate && (
                                                    <div className="revised-dates">
                                                      <p className="heading">
                                                        Revised/Actual:
                                                      </p>
                                                      <p className="date">
                                                        {(!!milestone.revisedScheduledFinishDate &&
                                                          moment(
                                                            get(
                                                              milestone,
                                                              "revisedScheduledFinishDate",
                                                              null
                                                            )
                                                          ).format("MMMM") +
                                                            moment(
                                                              get(
                                                                milestone,
                                                                "revisedScheduledFinishDate",
                                                                null
                                                              )
                                                            ).format(" DD") +
                                                            prefixRevisedFinish +
                                                            moment(
                                                              get(
                                                                milestone,
                                                                "revisedScheduledFinishDate",
                                                                null
                                                              )
                                                            ).format(
                                                              ", YYYY"
                                                            )) ||
                                                          "NA"}
                                                      </p>
                                                    </div>
                                                  )}
                                                </div>
                                              </div>
                                              <div className="scheduled-dates">
                                                <h6>RELATED ISSUES</h6>
                                                <div className="dates">
                                                  <div className="original-dates">
                                                    <p>Un-resolved</p>
                                                    <p className="date">
                                                      {get(
                                                        milestone,
                                                        "milestoneIssueCountDTO.openIssueCount",
                                                        0
                                                      )}
                                                    </p>
                                                  </div>
                                                  <div className="revised-dates">
                                                    <p>Resolved</p>
                                                    <p className="date">
                                                      {get(
                                                        milestone,
                                                        "milestoneIssueCountDTO.closedIssueCount",
                                                        0
                                                      )}
                                                    </p>
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                            <div className="delay-authority">
                                              <div className="scheduled-dates">
                                                <h6>REASON OF DELAY</h6>
                                                {get(
                                                  milestone,
                                                  "reasonForDelay"
                                                ) ? (
                                                  <div className="delay-reason">
                                                    <ReadMore
                                                      // length={300}
                                                      clamp={2}
                                                      content={
                                                        get(
                                                          milestone,
                                                          "reasonForDelay",
                                                          ""
                                                        ) || "NA"
                                                      }
                                                    />
                                                  </div>
                                                ) : (
                                                  <div>NA</div>
                                                )}
                                              </div>
                                              <div className="scheduled-dates">
                                                <h6>
                                                  RESPONSIBLE AGENCY/AUTHORITY
                                                </h6>
                                                <div className="delay-reason">
                                                  {get(
                                                    milestone,
                                                    "responsibleAuthorityName",
                                                    ""
                                                  ) === "Others"
                                                    ? get(
                                                        milestone,
                                                        "otherResponsibleAuthority",
                                                        ""
                                                      ) || "NA"
                                                    : get(
                                                        milestone,
                                                        "responsibleAuthorityName",
                                                        ""
                                                      ) || "NA"}
                                                </div>
                                              </div>
                                              <div className="scheduled-dates">
                                                <h6>
                                                  DEPENDENCY TYPE
                                                  <OverlayTrigger
                                                    placement="top"
                                                    delay={{
                                                      show: 250,
                                                      hide: 400
                                                    }}
                                                    overlay={
                                                      <Tooltip
                                                        className={`dependency-tooltip`}
                                                      >
                                                        Dependency Type shows
                                                        dependency of one
                                                        milestone on another
                                                      </Tooltip>
                                                    }
                                                  >
                                                    <img
                                                      onClick={
                                                        this
                                                          .handleDependencyModal
                                                      }
                                                      src={MilestoneInfoIcon}
                                                      className="dependency-icon"
                                                    />
                                                  </OverlayTrigger>
                                                </h6>
                                                <div className="dates">
                                                  <div className="original-dates">
                                                    <p className="heading">
                                                      {
                                                        DETAILS_DEPENDENT_TYPE[
                                                          get(
                                                            milestone,
                                                            "dependencyType",
                                                            ""
                                                          )
                                                        ]
                                                      }
                                                    </p>
                                                    <p className="date">
                                                      {dependencyDescription(
                                                        get(
                                                          milestone,
                                                          "dependencyType",
                                                          ""
                                                        ),
                                                        get(
                                                          milestone,
                                                          "milestone.name",
                                                          ""
                                                        ),
                                                        get(
                                                          milestone,
                                                          "dependentOn.name",
                                                          ""
                                                        )
                                                      )}
                                                    </p>
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </Fragment>
                                    ) : (
                                      <Fragment>
                                        <div className="project-milestone-details">
                                          <div className="pmd-heading">
                                            <h5 className="pmd-milestone-name">
                                              {get(
                                                milestone,
                                                "milestone.name",
                                                ""
                                              )}
                                            </h5>
                                            {!!milestone &&
                                              !!milestone.timeDelay && (
                                                <p
                                                  style={{
                                                    background:
                                                      statusColors[
                                                        get(
                                                          milestone,
                                                          "timeDelay.key",
                                                          ""
                                                        )
                                                      ]
                                                  }}
                                                  className="pmd-status"
                                                >
                                                  {get(
                                                    milestone,
                                                    "timeDelay.key",
                                                    ""
                                                  )}
                                                </p>
                                              )}
                                          </div>
                                          <div className="milestones-wrapper">
                                            <div className="dates-issues">
                                              <div className="scheduled-dates disable-width">
                                                <h6>REASON FOR DISABLING</h6>
                                                <p>
                                                  {get(
                                                    milestone,
                                                    "disableReason",
                                                    ""
                                                  )}
                                                </p>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </Fragment>
                                    );
                                  })}
                              </TabPanel>
                            )
                        )}
                    </Tabs>
                  </TabPanel>
                ))}
            </Tabs>
            <hr
              className="cabinet-create-project-hr"
              style={{ marginTop: "-0.5rem" }}
            />
          </>
        ) : null}
        <div class="pmg-heading-container mt-4">
          <div class="left-border" />
          <h2>PMG MILESTONES</h2>
        </div>
        <Tabs selectedIndex={bucketIdx} className="project-details-milestones">
          <TabList className="buckets-tab-wrapper">
            {!isEmpty(bucketMilestoneCOS) &&
              bucketMilestoneCOS.map((bucket, bucketIdx) => (
                <Tab
                  onClick={() =>
                    this.getBucketIndex(bucket.bucketId, bucketIdx)
                  }
                  className="buckets-tab"
                >
                  {get(bucket, "bucketName", "")}
                </Tab>
              ))}
          </TabList>
          {!isEmpty(bucketMilestoneCOS) &&
            bucketMilestoneCOS.map((bucket, bucketIdx) => (
              <TabPanel key={bucketIdx}>
                {bucket.bucketId ===
                  (bucketId
                    ? bucketId
                    : !isEmpty(bucketMilestoneCOS[0]) &&
                      bucketMilestoneCOS[0].bucketId) && (
                  <Tabs
                    selectedIndex={tableIndex}
                    className="phases-details-wrap"
                  >
                    {bucket.completed ? (
                      <div className="complete-status-temp">
                        <p
                          style={{
                            background: "#5CB550"
                          }}
                          className="pmd-status"
                        >
                          {" "}
                          COMPLETED
                        </p>
                        {get(bucket, "bucketStatusDTO.delayInDays") &&
                        get(bucket, "bucketStatusDTO.delayInDays") > 0 &&
                        get(bucket, "bucketStatusDTO.status") ===
                          "COMPLETED" ? (
                          <div className="delayed-by-box">
                            <Image src={IconTime} alt="Time" /> Delay:{" "}
                            <span>
                              {get(bucket, "bucketStatusDTO.delayInDays", "")}{" "}
                              days
                            </span>{" "}
                          </div>
                        ) : null}
                      </div>
                    ) : null}
                    {bucket.completed && (
                      <>
                        <div className="completed-bucket-dates">
                          <div className="scheduled-dates">
                            <h6>SCHEDULED DATE OF START</h6>
                            <div className="dates">
                              <div className="original-dates">
                                <p className="heading">Original:</p>
                                <p className="date">
                                  {(!!bucket.originalScheduledStartDate &&
                                    moment(
                                      get(
                                        bucket,
                                        "originalScheduledStartDate",
                                        null
                                      )
                                    ).format("MMMM") +
                                      moment(
                                        get(
                                          bucket,
                                          "originalScheduledStartDate",
                                          null
                                        )
                                      ).format(" DD") +
                                      this.getDateSuffix(
                                        moment(
                                          get(
                                            bucket,
                                            "originalScheduledStartDate",
                                            null
                                          )
                                        ).format("DD")
                                      ) +
                                      moment(
                                        get(
                                          bucket,
                                          "originalScheduledStartDate",
                                          null
                                        )
                                      ).format(", YYYY")) ||
                                    "NA"}
                                </p>
                              </div>
                              <div className="revised-dates">
                                <p className="heading">Revised/Actual:</p>
                                <p className="date">
                                  {(!!bucket.revisedScheduledStartDate &&
                                    moment(
                                      get(
                                        bucket,
                                        "revisedScheduledStartDate",
                                        null
                                      )
                                    ).format("MMMM") +
                                      moment(
                                        get(
                                          bucket,
                                          "revisedScheduledStartDate",
                                          null
                                        )
                                      ).format(" DD") +
                                      this.getDateSuffix(
                                        moment(
                                          get(
                                            bucket,
                                            "revisedScheduledStartDate",
                                            null
                                          )
                                        ).format("DD")
                                      ) +
                                      moment(
                                        get(
                                          bucket,
                                          "revisedScheduledStartDate",
                                          null
                                        )
                                      ).format(", YYYY")) ||
                                    "NA"}
                                </p>
                              </div>
                            </div>
                          </div>
                          <div className="scheduled-dates">
                            <h6>SCHEDULED DATE OF FINISH</h6>
                            <div className="dates">
                              <div className="original-dates">
                                <p className="heading">Original:</p>
                                <p className="date">
                                  {(!!bucket.originalScheduledFinishDate &&
                                    moment(
                                      get(
                                        bucket,
                                        "originalScheduledFinishDate",
                                        null
                                      )
                                    ).format("MMMM") +
                                      moment(
                                        get(
                                          bucket,
                                          "originalScheduledFinishDate",
                                          null
                                        )
                                      ).format(" DD") +
                                      this.getDateSuffix(
                                        moment(
                                          get(
                                            bucket,
                                            "originalScheduledFinishDate",
                                            null
                                          )
                                        ).format("DD")
                                      ) +
                                      moment(
                                        get(
                                          bucket,
                                          "originalScheduledFinishDate",
                                          null
                                        )
                                      ).format(", YYYY")) ||
                                    "NA"}
                                </p>
                              </div>
                              <div className="revised-dates">
                                <p className="heading">Revised/Actual:</p>
                                <p className="date">
                                  {(!!bucket.revisedScheduledFinishDate &&
                                    moment(
                                      get(
                                        bucket,
                                        "revisedScheduledFinishDate",
                                        null
                                      )
                                    ).format("MMMM") +
                                      moment(
                                        get(
                                          bucket,
                                          "revisedScheduledFinishDate",
                                          null
                                        )
                                      ).format(" DD") +
                                      this.getDateSuffix(
                                        moment(
                                          get(
                                            bucket,
                                            "revisedScheduledFinishDate",
                                            null
                                          )
                                        ).format("DD")
                                      ) +
                                      moment(
                                        get(
                                          bucket,
                                          "revisedScheduledFinishDate",
                                          null
                                        )
                                      ).format(", YYYY")) ||
                                    "NA"}
                                </p>
                              </div>
                            </div>
                          </div>
                          {!!bucket &&
                            (bucket.bucketType === "COST_AND_DATES" ||
                              bucket.bucketType ===
                                "COST_AND_DATES_AND_AREA") && (
                              <div className="scheduled-dates">
                                <h6>{bucket.bucketName} Cost</h6>
                                <div className="dates">
                                  <div className="original-dates">
                                    <p className="heading">Original:</p>
                                    <p className="date">
                                      &#x20B9;{bucket.originalCost} Cr.
                                    </p>
                                  </div>
                                  <div className="revised-dates">
                                    <p className="heading">Revised/Actual:</p>
                                    <p className="date">
                                      &#x20B9;{bucket.revisedCost} Cr.
                                    </p>
                                  </div>
                                </div>
                              </div>
                            )}
                          {!!bucket &&
                            (bucket.bucketType ===
                              "COST_AND_DATES_AND_AREA" && (
                              <div className="scheduled-dates">
                                <h6>{bucket.bucketName} Area</h6>
                                <div className="dates">
                                  <div className="original-dates">
                                    <p className="heading">Original:</p>
                                    <p className="date">
                                      {bucket.originalArea} Ha.
                                    </p>
                                  </div>
                                  <div className="revised-dates">
                                    <p className="heading">Revised/Actual:</p>
                                    <p className="date">
                                      {bucket.revisedArea} Ha.
                                    </p>
                                  </div>
                                </div>
                              </div>
                            ))}
                        </div>
                        <div>
                          <div className="scheduled-dates">
                            <h6>REASON FOR DELAY</h6>
                            <p className="date">{bucket.bucketDelayReason}</p>
                          </div>
                        </div>
                      </>
                    )}
                    {!bucket.completed && !bucket.disabled ? (
                      <div className="activity-head-wrap">
                        <h5 className="activity-heading">
                          {get(bucket, "bucketName")}
                        </h5>
                        <div className="pmd-status-wrapper">
                          <p
                            style={{
                              background:
                                statusColors[
                                  get(bucket, "bucketStatusDTO.status", "NA")
                                ]
                            }}
                            className="pmd-status"
                          >
                            {
                              getStatus[
                                get(bucket, "bucketStatusDTO.status", "NA")
                              ]
                            }
                          </p>
                          {get(bucket, "bucketStatusDTO.delayInDays") &&
                          (get(bucket, "bucketStatusDTO.status") ===
                            "DELAYED" ||
                            get(bucket, "bucketStatusDTO.status") ===
                              "COMPLETED") ? (
                            <div className="delayed-by-box">
                              <Image src={IconTime} alt="Time" /> Delay:{" "}
                              <span>
                                {get(bucket, "bucketStatusDTO.delayInDays", "")}{" "}
                                days
                              </span>{" "}
                            </div>
                          ) : null}
                        </div>
                      </div>
                    ) : null}
                    {!bucket.completed && (
                      <TabList className="phases-tab-wrapper">
                        {(!isEmpty(bucket) &&
                          !isEmpty(bucket.milestoneTableDataCOS) &&
                          bucket.milestoneTableDataCOS.map(table => (
                            <Tab
                              onClick={() =>
                                this.getTableIndex(table.tableIndex)
                              }
                              className="phases-tab"
                            >
                              {get(table, "table.name", "")}
                            </Tab>
                          ))) ||
                          (bucket.disableReason ? (
                            <div className="disabled-bucket">
                              <h5 className="bucket-disabled-msg">
                                Project Stage is Disabled
                              </h5>
                              <p className="reason-head">
                                Reason -
                                <span className="reason">
                                  <ReadMore
                                    // length={300}
                                    content={bucket.disableReason}
                                  />
                                </span>
                              </p>
                            </div>
                          ) : null)}
                      </TabList>
                    )}
                    {!isEmpty(bucket) &&
                      !isEmpty(bucket.milestoneTableDataCOS) &&
                      bucket.milestoneTableDataCOS.map(
                        table =>
                          !bucket.completed && (
                            <TabPanel key={table.tableIndex}>
                              {get(table, "phaseName", "") ? (
                                <div className="phase-name-box">
                                  {get(table, "phaseName", "")}
                                </div>
                              ) : null}
                              <div className="progress-box-wrapper">
                                {get(table, "phaseOriginalCost", "") ? (
                                  <div className="progress-box">
                                    Original Cost (Cr.):{" "}
                                    <span>
                                      &#8377;{" "}
                                      {get(table, "phaseOriginalCost", "")} Cr.
                                    </span>
                                  </div>
                                ) : null}
                                {get(table, "phaseRevisedCost", "") ? (
                                  <div className="progress-box">
                                    Revised Cost (Cr.):{" "}
                                    <span>
                                      &#8377;{" "}
                                      {get(table, "phaseRevisedCost", "")} Cr.
                                    </span>
                                  </div>
                                ) : null}
                                {get(table, "physicalPercentage", "") ? (
                                  <div className="progress-box">
                                    Physical Progress:{" "}
                                    <span>
                                      {get(table, "physicalPercentage", "")}%
                                    </span>
                                  </div>
                                ) : null}
                                {get(table, "financialPercentage", "") ? (
                                  <div className="progress-box">
                                    Financial Progress:{" "}
                                    <span>
                                      {get(table, "financialPercentage", "")}%
                                    </span>
                                  </div>
                                ) : null}
                                {get(table, "asOfDate", "") ? (
                                  <div className="progress-box">
                                    Progress As of Date:{" "}
                                    <span>
                                      {moment(
                                        get(table, "asOfDate", "")
                                      ).format("DD/MM/YYYY")}
                                    </span>
                                  </div>
                                ) : null}
                                {get(table, "phaseProponent.name", "") ? (
                                  <div className="progress-box">
                                    Project Proponent:{" "}
                                    <span>
                                      {get(table, "phaseProponent.name", "")}{" "}
                                      {get(
                                        table,
                                        "phaseProponent.groupOrganization",
                                        ""
                                      ) && (
                                        <span className="proponent-org">
                                          (
                                          {get(
                                            table,
                                            "phaseProponent.groupOrganization",
                                            ""
                                          )}
                                          )
                                        </span>
                                      )}
                                    </span>
                                  </div>
                                ) : null}
                              </div>
                              <div className="activity-head-wrap">
                                <h5 className="activity-heading">
                                  Milestone/Activity
                                </h5>
                              </div>
                              {table.tableIndex === tableIndex &&
                                !isEmpty(table.milestoneDataCOS) &&
                                sortBy(
                                  table.milestoneDataCOS,
                                  o => o.disabled
                                ).map(milestone => {
                                  let prefixOriginalStart = this.getDateSuffix(
                                    moment(
                                      get(
                                        milestone,
                                        "originalScheduledStartDate",
                                        null
                                      )
                                    ).format("DD")
                                  );
                                  let prefixRevisedStart = this.getDateSuffix(
                                    moment(
                                      get(
                                        milestone,
                                        "revisedScheduledStartDate",
                                        null
                                      )
                                    ).format("DD")
                                  );
                                  let prefixOriginalFinish = this.getDateSuffix(
                                    moment(
                                      get(
                                        milestone,
                                        "originalScheduledFinishDate",
                                        null
                                      )
                                    ).format("DD")
                                  );
                                  let prefixRevisedFinish = this.getDateSuffix(
                                    moment(
                                      get(
                                        milestone,
                                        "revisedScheduledFinishDate",
                                        null
                                      )
                                    ).format("DD")
                                  );
                                  return !bucket.completed &&
                                    !milestone.disabled ? (
                                    <Fragment>
                                      <div className="project-milestone-details">
                                        <div className="pmd-heading">
                                          <h5 className="pmd-milestone-name">
                                            {get(
                                              milestone,
                                              "milestone.name",
                                              ""
                                            )}
                                          </h5>
                                          {!!milestone &&
                                            !!milestone.timeDelay && (
                                              <div className="pmd-status-wrapper">
                                                <p
                                                  style={{
                                                    background:
                                                      statusColors[
                                                        get(
                                                          milestone,
                                                          "timeDelay.key",
                                                          ""
                                                        )
                                                      ]
                                                  }}
                                                  className="pmd-status"
                                                >
                                                  {get(
                                                    milestone,
                                                    "timeDelay.key",
                                                    ""
                                                  )}
                                                </p>
                                                {(get(
                                                  milestone,
                                                  "timeDelay.value"
                                                ) &&
                                                  get(
                                                    milestone,
                                                    "timeDelay.value"
                                                  ) > 0 &&
                                                  get(
                                                    milestone,
                                                    "timeDelay.key"
                                                  ) !== "Delay Expected") ||
                                                get(
                                                  milestone,
                                                  "timeDelay.key"
                                                ) === "Delayed" ? (
                                                  <div className="delayed-by-box">
                                                    <Image
                                                      src={IconTime}
                                                      alt="Time"
                                                    />{" "}
                                                    Delay:{" "}
                                                    <span>
                                                      {get(
                                                        milestone,
                                                        "timeDelay.value",
                                                        ""
                                                      )}{" "}
                                                      days
                                                    </span>{" "}
                                                  </div>
                                                ) : null}
                                              </div>
                                            )}
                                        </div>
                                        <div className="milestones-wrapper">
                                          <div className="dates-issues">
                                            <div className="scheduled-dates">
                                              <h6>SCHEDULED DATE OF START</h6>
                                              <div className="dates">
                                                <div className="original-dates">
                                                  <p className="heading">
                                                    Original:
                                                  </p>
                                                  <p className="date">
                                                    {(!!milestone.originalScheduledStartDate &&
                                                      moment(
                                                        get(
                                                          milestone,
                                                          "originalScheduledStartDate",
                                                          null
                                                        )
                                                      ).format("MMMM") +
                                                        moment(
                                                          get(
                                                            milestone,
                                                            "originalScheduledStartDate",
                                                            null
                                                          )
                                                        ).format(" DD") +
                                                        prefixOriginalStart +
                                                        moment(
                                                          get(
                                                            milestone,
                                                            "originalScheduledStartDate",
                                                            null
                                                          )
                                                        ).format(", YYYY")) ||
                                                      "NA"}
                                                  </p>
                                                </div>
                                                {!!milestone.revisedScheduledStartDate && (
                                                  <div className="revised-dates">
                                                    <p className="heading">
                                                      Revised/Actual:
                                                    </p>
                                                    <p className="date">
                                                      {(!!milestone.revisedScheduledStartDate &&
                                                        moment(
                                                          get(
                                                            milestone,
                                                            "revisedScheduledStartDate",
                                                            null
                                                          )
                                                        ).format("MMMM") +
                                                          moment(
                                                            get(
                                                              milestone,
                                                              "revisedScheduledStartDate",
                                                              null
                                                            )
                                                          ).format(" DD") +
                                                          prefixRevisedStart +
                                                          moment(
                                                            get(
                                                              milestone,
                                                              "revisedScheduledStartDate",
                                                              null
                                                            )
                                                          ).format(", YYYY")) ||
                                                        "NA"}
                                                    </p>
                                                  </div>
                                                )}
                                              </div>
                                            </div>
                                            <div className="scheduled-dates">
                                              <h6>SCHEDULED DATE OF FINISH</h6>
                                              <div className="dates">
                                                <div className="original-dates">
                                                  <p className="heading">
                                                    Original:
                                                  </p>
                                                  <p className="date">
                                                    {(!!milestone.originalScheduledFinishDate &&
                                                      moment(
                                                        get(
                                                          milestone,
                                                          "originalScheduledFinishDate",
                                                          null
                                                        )
                                                      ).format("MMMM") +
                                                        moment(
                                                          get(
                                                            milestone,
                                                            "originalScheduledFinishDate",
                                                            null
                                                          )
                                                        ).format(" DD") +
                                                        prefixOriginalFinish +
                                                        moment(
                                                          get(
                                                            milestone,
                                                            "originalScheduledFinishDate",
                                                            null
                                                          )
                                                        ).format(", YYYY")) ||
                                                      "NA"}
                                                  </p>
                                                </div>
                                                {!!milestone.revisedScheduledFinishDate && (
                                                  <div className="revised-dates">
                                                    <p className="heading">
                                                      Revised/Actual:
                                                    </p>
                                                    <p className="date">
                                                      {(!!milestone.revisedScheduledFinishDate &&
                                                        moment(
                                                          get(
                                                            milestone,
                                                            "revisedScheduledFinishDate",
                                                            null
                                                          )
                                                        ).format("MMMM") +
                                                          moment(
                                                            get(
                                                              milestone,
                                                              "revisedScheduledFinishDate",
                                                              null
                                                            )
                                                          ).format(" DD") +
                                                          prefixRevisedFinish +
                                                          moment(
                                                            get(
                                                              milestone,
                                                              "revisedScheduledFinishDate",
                                                              null
                                                            )
                                                          ).format(", YYYY")) ||
                                                        "NA"}
                                                    </p>
                                                  </div>
                                                )}
                                              </div>
                                            </div>
                                            <div className="scheduled-dates">
                                              <h6>RELATED ISSUES</h6>
                                              <div className="dates">
                                                <div className="original-dates">
                                                  <p>Un-resolved</p>
                                                  <p className="date">
                                                    {get(
                                                      milestone,
                                                      "milestoneIssueCountDTO.openIssueCount",
                                                      0
                                                    )}
                                                  </p>
                                                </div>
                                                <div className="revised-dates">
                                                  <p>Resolved</p>
                                                  <p className="date">
                                                    {get(
                                                      milestone,
                                                      "milestoneIssueCountDTO.closedIssueCount",
                                                      0
                                                    )}
                                                  </p>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                          <div className="delay-authority">
                                            <div className="scheduled-dates">
                                              <h6>REASON OF DELAY</h6>
                                              {get(
                                                milestone,
                                                "reasonForDelay"
                                              ) ? (
                                                <div className="delay-reason">
                                                  <ReadMore
                                                    // length={300}
                                                    clamp={2}
                                                    content={
                                                      get(
                                                        milestone,
                                                        "reasonForDelay",
                                                        ""
                                                      ) || "NA"
                                                    }
                                                  />
                                                </div>
                                              ) : (
                                                <div>NA</div>
                                              )}
                                            </div>
                                            <div className="scheduled-dates">
                                              <h6>
                                                RESPONSIBLE AGENCY/AUTHORITY
                                              </h6>
                                              <div className="delay-reason">
                                                {get(
                                                  milestone,
                                                  "responsibleAuthorityName",
                                                  ""
                                                ) === "Others"
                                                  ? get(
                                                      milestone,
                                                      "otherResponsibleAuthority",
                                                      ""
                                                    ) || "NA"
                                                  : get(
                                                      milestone,
                                                      "responsibleAuthorityName",
                                                      ""
                                                    ) || "NA"}
                                              </div>
                                            </div>
                                            <div className="scheduled-dates">
                                              <h6>
                                                DEPENDENCY TYPE
                                                <OverlayTrigger
                                                  placement="top"
                                                  delay={{
                                                    show: 250,
                                                    hide: 400
                                                  }}
                                                  overlay={
                                                    <Tooltip
                                                      className={`dependency-tooltip`}
                                                    >
                                                      Dependency Type shows
                                                      dependency of one
                                                      milestone on another
                                                    </Tooltip>
                                                  }
                                                >
                                                  <img
                                                    onClick={
                                                      this.handleDependencyModal
                                                    }
                                                    src={MilestoneInfoIcon}
                                                    className="dependency-icon"
                                                  />
                                                </OverlayTrigger>
                                              </h6>
                                              <div className="dates">
                                                <div className="original-dates">
                                                  <p className="heading">
                                                    {
                                                      DETAILS_DEPENDENT_TYPE[
                                                        get(
                                                          milestone,
                                                          "dependencyType",
                                                          ""
                                                        )
                                                      ]
                                                    }
                                                  </p>
                                                  <p className="date">
                                                    {dependencyDescription(
                                                      get(
                                                        milestone,
                                                        "dependencyType",
                                                        ""
                                                      ),
                                                      get(
                                                        milestone,
                                                        "milestone.name",
                                                        ""
                                                      ),
                                                      get(
                                                        milestone,
                                                        "dependentOn.name",
                                                        ""
                                                      )
                                                    )}
                                                  </p>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </Fragment>
                                  ) : (
                                    <Fragment>
                                      <div className="project-milestone-details">
                                        <div className="pmd-heading">
                                          <h5 className="pmd-milestone-name">
                                            {get(
                                              milestone,
                                              "milestone.name",
                                              ""
                                            )}
                                          </h5>
                                          {!!milestone &&
                                            !!milestone.timeDelay && (
                                              <p
                                                style={{
                                                  background:
                                                    statusColors[
                                                      get(
                                                        milestone,
                                                        "timeDelay.key",
                                                        ""
                                                      )
                                                    ]
                                                }}
                                                className="pmd-status"
                                              >
                                                {get(
                                                  milestone,
                                                  "timeDelay.key",
                                                  ""
                                                )}
                                              </p>
                                            )}
                                        </div>
                                        <div className="milestones-wrapper">
                                          <div className="dates-issues">
                                            <div className="scheduled-dates disable-width">
                                              <h6>REASON FOR DISABLING</h6>
                                              <p>
                                                {get(
                                                  milestone,
                                                  "disableReason",
                                                  ""
                                                )}
                                              </p>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </Fragment>
                                  );
                                })}
                            </TabPanel>
                          )
                      )}
                  </Tabs>
                )}
              </TabPanel>
            ))}
        </Tabs>
        {/* Dependency Type Info Popup */}
        <Modal
          show={showInfoPopup}
          onHide={this.handleDependencyModal}
          className="dependency-modal"
        >
          <Modal.Header closeButton>
            <Modal.Title>
              Dependency of the milestone on other milestones
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div>
              <h2>Independent</h2>
              <p>Milestone is executed Independently</p>
            </div>
            <div>
              <h2>Finish to Start (A → B)</h2>
              <p>Milestone B can only start when Milestone A has finished</p>
            </div>
            <div>
              <h2>Start to Start (A → B)</h2>
              <p>Milestone B can only start when Milestone A has started</p>
            </div>
            <div>
              <h2>Finish to Finish (A → B)</h2>
              <p>Milestone B can only finish when Milestone A has finished</p>
            </div>
            <div>
              <h2>Start to Finish (A → B)</h2>
              <p>Milestone B can only finish when Milestone A has started</p>
            </div>
            <div>
              <b>E.g.:</b> If Milestone B can only start when Milestone A is
              finished, select the dependency type as ‘Finish to Start’ against
              Milestone B and enter A in the <b>‘Linked Activity’</b> column.
            </div>
          </Modal.Body>
        </Modal>
      </Fragment>
    );
  }
}

export default ProjectMilestoneDetails;
